@if (scriptStatus.busy) {
<div class="p-a flex flex-middle flex-justify-center">
    <i class="fs-10 icon-loading"
       aria-hidden="true"></i>
</div>
}

<result [status]="scriptStatus"
        duration="permanent" />

<div [ngClass]="{'visually-hidden': scriptStatus.busy}"
     #klarnacontainer></div>